import { render, staticRenderFns } from "./AccountSettingRegional.vue?vue&type=template&id=819f721e&"
import script from "./AccountSettingRegional.vue?vue&type=script&lang=js&"
export * from "./AccountSettingRegional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports